import { ANNOUNCEMENT_API_URL, fmhNpiAPI } from 'api/APIBase';

export async function getCarouselImage({
    messageId,
    filename,
}: {
    messageId: string;
    filename: string;
}) {
    const url = `${ANNOUNCEMENT_API_URL}/home_screen/message/${messageId}/images/${filename}`;
    return fmhNpiAPI({ url })
        .get()
        .blob((blob) => new File([blob], filename));
}
